/**
 * ActionButton — Sprint 13 S13-29.
 *
 * Boton compacto de accion para filas de tablas (Editar, Desactivar,
 * Cancelar, etc.). Reemplaza los `<button class="text-XXX hover:underline">`
 * dispersos en las paginas.
 *
 * 4 variantes:
 * - neutral: gris discreto (acciones secundarias)
 * - edit: rojo institucional (editar)
 * - danger: rojo de alarma (desactivar/cancelar/eliminar)
 * - success: verde (reactivar)
 */
import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'neutral' | 'edit' | 'danger' | 'success';

interface ActionButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  children: ReactNode;
}

const VARIANT_CLASS: Record<Variant, string> = {
  neutral:
    'text-text-secondary hover:text-text-primary hover:bg-bg-elevated border-white/15',
  edit: 'text-admin-red hover:bg-admin-red/10 border-admin-red/30',
  danger:
    'text-state-danger hover:bg-state-danger/10 border-state-danger/30',
  success:
    'text-state-success hover:bg-state-success/10 border-state-success/30',
};

export function ActionButton({
  variant = 'neutral',
  className = '',
  type = 'button',
  children,
  ...rest
}: ActionButtonProps) {
  return (
    <button
      type={type}
      className={`inline-flex items-center px-2.5 py-1 text-xs font-medium rounded border-[0.5px] transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${VARIANT_CLASS[variant]} ${className}`.trim()}
      {...rest}
    >
      {children}
    </button>
  );
}
